<!-- 订单详情 -->
<template>
  <DetailPage class="order-detail-box" :name="`订单编号：${orderId}`" :backRoute="'orderList'" :param="param">
    <template #detailMain >
        <div class="detail-content" :class="{'detail-content-verify': detailType == 2}" v-loading="pageLoading" >
          <template v-if="processDetail">
             <div class="detail-content-wrapper">
                <el-row class="content-item" :gutter="20">
                    <el-col :span="8" class="hd-group">
                      <div class="group-item">
                        <span class="key">用户类型：</span>
                        <span class="value">{{ processDetail.userid? '个人用户': '企业用户' }}</span>
                      </div>
                      <div class="group-item">
                        <span class="key">企业名称：</span>
                        <span class="value">{{ processDetail.companyname || '-'}}</span>
                      </div>
                      <div class="group-item">
                        <span class="key">公司管理员：</span>
                        <span class="value">{{ processDetail.companymanagername || '-'}}</span>
                      </div>
                    </el-col>

                    <el-col :span="8" class="hd-group">
                      <div class="group-item">
                        <span class="key">订单类型：</span>
                        <span class="value">{{ processDetail.type==1? '试用订单': '正式订单' }}</span>
                      </div>

                      <div class="group-item">
                        <span class="key">生效日期：</span>
                        <span class="value">{{ processDetail.effectivetime || '-' }}</span>
                      </div>
                      <div class="group-item">
                        <span class="key">订单金额：</span>
                        <span class="value color-red">{{ processDetail.price? processDetail.price.toLocaleString(): 0}} 元</span>
                      </div>
                    </el-col>

                    <el-col :span="8" class="hd-group">
                      <div class="group-item">
                        <span class="key">操作人：</span>
                        <span class="value">{{  processDetail.adminusername || '-'}}</span>
                      </div>
                      <div class="group-item">
                        <span class="key">操作时间：</span>
                        <span class="value">{{ processDetail.intime || '-'}}</span>
                      </div>
                      <div class="group-item">
                        <span class="key">订单状态：</span>
                        <span class="value">
                          <span class="myTag" :class="processDetail.stateverify == 1? 'warning': 'primary'" >{{processDetail.stateverify == 1? "申请中": '审核通过' }}</span>
                        </span>
                      </div>
                    </el-col>

                    <el-col :span="24" class="hd-group">
                        <div class="group-item">
                          <span class="key">审核意见：</span>
                          <span class="value">{{ processDetail.comments || '-' }}</span>
                        </div>
                    </el-col>
                </el-row>

                <section class="detail-bd">
                  <header class="title">产品清单（{{ processDetail.auProList.length }}）</header>
                  <SelectedProduct :productLists="processDetail.auProList" @renew="handleRenewOrder"></SelectedProduct>
                </section>
                

                <footer class="comments-box" v-if="isShowComment">
                   <h4 class="title">请输入审核意见：</h4>
                   <el-input type="textarea" :rows="3" placeholder="请输入" v-model="comments" @change="handerChangeComments"></el-input>
                   <span class="status-text color-red" v-show="isShowError">审核意见不能为空</span>
                </footer>
               
              </div>

              <footer class="detail-ft">
                 <!--1：申请状态 2：审核完成状态  -->
                <template v-if="isShowComment">
                  <el-button type="primary" :loading="dialogLoading" plain @click="isShowComment = false">取消</el-button>
                  <el-button type="primary" :loading="dialogLoading" @click="handerVerify(1)">提 交</el-button>
                </template>

                <template v-else>
                    <el-button type="primary" :loading="dialogLoading" plain @click="isShowComment = true">审核不通过</el-button>
                    <el-button type="primary" :loading="dialogLoading"  @click="handerVerify(2)">审核通过</el-button>
                </template>
               
              </footer>
            </template>
        </div>

        <ModalFormOrder :visible.sync="visibleRenew"  :productInfo="productInfo" v-if="visibleRenew" @getDetail="getDetail(token, checkCode)" />
    </template>
  </DetailPage>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_User ,API_Product,imgURLs, API_Order} from '../../../api/index.js'
import DetailPage from '@/components/DetailPage'
import SelectedProduct from './SelectedProduct'
import ModalFormOrder from './ModalFormOrder'
import  utils  from '@/utils/index'
export default {
  data () {
    return {
      pageLoading: true,
      dialogLoading: false,
      orderId: '',
      detailType: '1',  // 1、普通详情  2、审核

      token: '',
      checkCode: '',

      processDetail: null,
      comments: '',    // 审核意见
      isShowComment: false,
      isShowError: false,
      
      // 续订
      visibleRenew: false, 
      productInfo: null,
      productList: [],
      param:{
        searchText:this.$route.query.searchText,
        souType:this.$route.query.souType,
        souAccount:this.$route.query.souAccount,
        fromtime:this.$route.query.fromtime,
        totime:this.$route.query.totime,
        pageNumber:this.$route.query.pageNumber,
        pageSize:this.$route.query.pageSize,
      }
    };
  },

  components: {
    DetailPage,
    SelectedProduct,
    ModalFormOrder
  },

  computed: {
  ...mapGetters({
    userInfo: 'userInfo'
  })
},

  created() {
    let { token, checkCode } = utils.getParamsByCookie();
    let { type, orderId } = this.$route.query
    this.orderId = orderId
    this.detailType = type
    this.token = token;
    this.checkCode = checkCode;

    this.getDetail(token, checkCode);

  },

  methods: {

    getDetail(token, checkCode) {
      let param = {
        token: token,
        checkCode: checkCode,
        id: this.$route.query.orderId,
      }
      this.pageLoading = true;
       API_Order.detailOrder(param).then(res => {
         if(res.data.code == 200) {
           this.processDetail = res.data.data
           try {
              // this.processDetail.product = JSON.parse(this.processDetail.product);
              // this.processDetail.product.forEach(item => {
              //   item.price = item.singlePrice
              //   item.name = item.productName;
              //   // item.logo = ''
              // })

              this.processDetail.auProList.forEach(item => {
                item.price = item.singlePrice
                item.name = item.productName
              })
           } catch(e) {
             this.processDetail.product = []
           }
         }
         this.pageLoading = false;
       })
    },

    handerChangeComments(val) {
      this.isShowError = val? false: true;
    },
    
    // 1：申请状态 2：审核完成状态
    handerVerify(status) {
      // 校验审核状态
      if(status == 1 && !this.comments) {
        this.isShowError = true;
        return;
      }
      
      let param = {
        token: this.token,
        checkCode: this.checkCode,

        id: this.$route.query.orderId,
        stateverify: status,
      }

      status == 1 && (param.comments = this.comments)
      this.dialogLoading = true; 
       API_Order.verifyOrder(param).then(res => {
         if(res.data.code == 200) {
           this.$message.success('审核成功')
           this.$router.push({path: 'orderList'})
         }
         this.dialogLoading = false;
       })

    },
    
    // 续订
    handleRenewOrder(product) {
      this.productInfo = product;
      // 订单编号
      this.productInfo.orderId = this.orderId;
      // 公司或用户id（企业订单、个人订单）
      let { companyid, userid, companyname, username } = this.processDetail
      this.productInfo.typeId = companyid || userid;

      this.productInfo.ower = companyid? companyname: username
      this.visibleRenew = true;
    }

    
  }
}

</script>
<style lang='scss' scoped>
.order-detail-box {
  * {
    box-sizing: border-box;
  }
  .detail-content-wrapper {
    height: 100%;
  }
  .detail-content-verify {
    .detail-content-wrapper {
      height: calc(100% - 61px);
      overflow: hidden;
      overflow-y: auto;
    }
    .detail-ft {
      display: block;
    }
  }
  .detail-content {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .content-item {
    margin-bottom: 20px;
    padding: 10px 60px 10px 60px;
    border-bottom: 1px dashed #DBDBDB;
    .group-item {
      display: flex;
      margin-bottom: 12px;
    }
    .key {
      display: inline-block;
      width: 90px;
      color: #666;
      font-size: 14px;
    }
    .value {
      flex: 1;
      margin-left: 5px;
      min-width: 1px;
      color: #333;
      font-size: 14px;
    }
  }

  .detail-bd {
    .title {
      margin-bottom: 10px;
      color: #666;
      font-size: 14px;
    }
  }

  .comments-box {
    padding-top: 30px;
    // border-top: 1px solid #ebebeb;
    .title {
      margin-bottom: 14px;
      font-weight: normal;
      color: #666;
      font-size: 14px;
    }

    .status-text {
      padding-top: 4px;
      font-size: 12px;
      transition: all .2s;
    }


  }

  .detail-ft {
    display: none;
    width: 100%;
    padding-top: 20px;
    text-align: right;
    border-top: 1px solid #ebebeb;
  }
}
</style>


// WEBPACK FOOTER //
// OrderDetail.vue?3f917cd6